import React from 'react'
import { CustomTitle } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { getProjectUnit } from 'src/core/helpers'
import { VintageItemPayload } from 'src/core/models'
import { projectFormKindSelector } from 'src/features'

interface VintageStockColumnProps { vintage: VintageItemPayload }

const VintageStockColumn: React.FC<VintageStockColumnProps> = ({ vintage }) => {
  const kind = useAppSelector(projectFormKindSelector)
  return <CustomTitle label={`${vintage.stock} ${getProjectUnit(kind)}`} type={null} />
}

export default VintageStockColumn
